export default "__VITE_ASSET__47405246__"